import * as R from 'ramda';
import { authRequest } from './utils';


/**
 * fetchContact :: String -> Promise Error Object
 */
export const fetchContact = _id =>
  authRequest({
    method: 'GET',
    url: `/contacts/${_id}`,
  })
    .then(({ data }) => data);


/**
 * fetchContacts :: Object -> Promise Error Object
 */
export const fetchContacts = ({
  page = 1,
  type,
  countries,
  searchTerm,
  simpleList,
  cancelToken,
  polling = false,
} = {}) => authRequest({
  method: 'GET',
  url: '/contacts',
  cancelToken,
  params: {
    page,
    type,
    countries,
    searchTerm,
    simpleList,
    ...(polling && { polling }),
  },
})
  .then(({ data, responseTime }) => ({ data, responseTime }));


/**
 * createContact :: Object -> Promise Error Object
 */
export const createContact = data =>
  authRequest({
    method: 'POST',
    url: '/contacts/create',
    data,
  })
    .then(res => res.data);


/**
 * updateContactById :: String -> Object -> Promise Error Object
 */
export const updateContactById = R.curry((_id, data) =>
  authRequest({
    method: 'PATCH',
    url: `/contacts/${_id}`,
    data,
  })
    .then(res => res.data));


/**
 * deleteContactById :: String -> Promise Error Object
 */
export const deleteContactById = _id =>
  authRequest({
    method: 'DELETE',
    url: `/contacts/${_id}`,
  });


/**
 * deleteContactWithRequestsById :: String -> Promise Error Object
 */
export const deleteContactWithRequestsById = _id =>
  authRequest({
    method: 'DELETE',
    url: `/contacts/${_id}`,
    params: { withRequests: true },
  });

/**
 * deleteContactThread :: String -> Promise
 */
export const deleteContactThread = threadId =>
  authRequest({
    method: 'DELETE',
    url: `/gmail/threads/${threadId}`,
  });



// WEBPACK FOOTER //
// ./src/api/apiko-api/contacts.js